// Module
var code = "<div class=\"dms-content-fullscreen\">\n    <div class=\"dms-content-wrapper\">\n        <div class=\"dms-content-header\"></div>\n        <div class=\"dms-content-container\"></div>\n    </div>\n</div>\n";
// Exports
export default code;